<template lang="pug">
    switcher.m-auto(
        @on-switch="() => { if (isActive) onStatusChange(item) }"
        :status="+item.status ? true : false"
        :title="{on: SWITCHERS_VALUES.active, off: SWITCHERS_VALUES.blocked}"
    )
</template>

<script>
//Components
import SwitcherStyleOne from '@/components/common/switchers/style-1';
//Configs
import { SWITCHERS_VALUES } from '@/configs/names.js';
//Store
/* eslint-disable no-unused-vars */
import { UsersNameSpace, UsersActionTypes } from '@/store/users/types';

export default {
    name: "DefaultUserStatus",
    components: {
       'switcher': SwitcherStyleOne, 
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        context: {
            type: Object,
            default: () => ({
                name_space: 'users',
                action: 'EditUser',
            }),
        },
        isActive: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        SWITCHERS_VALUES() {
            return SWITCHERS_VALUES
        },
    },
    methods: {
        async onStatusChange({ _id, status }) {
            let status_value = Number(status)
            status_value = !status_value
            await this.onChange({ id: _id, value: {status: status_value ? 1 : 0} })
            this.$emit('updated')
        },
        async onChange({ id, value }) {
            await this.$store.dispatch(`${this.context.name_space}/${this.context.action}`, { id, value })
        },
    }
}
</script>